import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EditContactService {
  constructor(private http: HttpClient) {}

  editContactDetails(email, requestBody) {
    const url = `${environment.backend_server_url_account}/update-contact?email=${email}`;
    return this.http.put(url, requestBody);
  }

  editContactDetailsOnAdd(email, requestBody) {
    const url = `${environment.backend_server_url_account}/update-contact-onadd?email=${email}`;
    return this.http.put(url, requestBody);
  }

  unsubscribeAgent(token) {
    const url = `${environment.backend_server_url_account}/agent/unsubscribe?token=${token}`;
    return this.http.get(url);
  }
}
